import {Helmet} from 'react-helmet'
import {useSearchParams} from 'react-router-dom'
import {useTranslation} from '@/translations/i18n.tsx'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {Text} from '@/components/ui/text/Text'
import {MailerTab, MailerTabs} from '@/features/mailer/components/mailer-tabs/MailerTabs'
import {MailerComposeTab} from '@/features/mailer/components/mailer-compose-tab/MailerComposeTab'
import {MailerHistoryTab} from '@/features/mailer/components/mailer-history-tab/MailerHistoryTab'
import {StyledCardWrapper, StyledHeadingTexts, StyledTabContent} from '@/pages/mailer/style'

export const Mailer = () => {
    const {t} = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()

    const activeTab: MailerTab = searchParams.get('tab') === 'history' ? 'history' : 'compose'

    const handleTabChange = (tab: MailerTab) => {
        setSearchParams(tab === 'history' ? {tab: 'history'} : {}, {replace: true})
    }

    return (
        <StyledCardWrapper>
            <Helmet title={t('mailer:title')} />
            <PageHeading justify="space-between">
                <StyledHeadingTexts>
                    <Text render="h1" size="textXl" weight="500">
                        {t('mailer:title')}
                    </Text>
                    <Text render="p" size="textSm" palette="neutral" shade="500">
                        {t('mailer:page_subtitle')}
                    </Text>
                </StyledHeadingTexts>
            </PageHeading>
            <MailerTabs active={activeTab} onChange={handleTabChange} />
            <StyledTabContent>{activeTab === 'compose' ? <MailerComposeTab /> : <MailerHistoryTab />}</StyledTabContent>
        </StyledCardWrapper>
    )
}

Mailer.displayName = 'Mailer'
